/**
 * Telling a send that failed apart from a send whose outcome is unknown.
 *
 * The backend answers POST /email/send only after the SMTP send, the save to
 * Sent, the inbox move and the portal hooks have all run, so a request that
 * times out, loses its connection or dies at the gateway may well have sent
 * the quote. Treating that as a failure put the RFQ back to NEW and invited a
 * second, duplicate quote to the customer.
 *
 * Kept out of emailService.ts so code that mocks that module wholesale still
 * gets the real classifier.
 */
export class SendOutcomeUnknownError extends Error {
  readonly outcomeUnknown = true;

  constructor(message: string) {
    super(message);
    this.name = 'SendOutcomeUnknownError';
  }
}

/**
 * True when the email may have gone out even though the request failed: our
 * own timeout, a dropped connection (fetch rejects with a TypeError) or a
 * gateway that gave up waiting on the backend. A response the backend itself
 * produced is a definite answer and returns false.
 */
export function isSendOutcomeUnknown(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as { outcomeUnknown?: unknown; name?: unknown };
  if (e.outcomeUnknown === true) return true;
  return e.name === 'AbortError' || e.name === 'TypeError';
}
